import { render, staticRenderFns } from "./jobStageItemProdTab.vue?vue&type=template&id=54fa7d2c"
import script from "./jobStageItemProdTab.vue?vue&type=script&lang=js"
export * from "./jobStageItemProdTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports